/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export var Tab = {
  key: 'Tab',
  which: 9,
  keyCode: 9
};
export var Enter = {
  key: 'Enter',
  which: 13,
  keyCode: 13
};
export var Escape = {
  key: ['Escape', // IE11 Escape
  'Esc'],
  which: 27,
  keyCode: 27
};
export var Space = {
  key: ' ',
  which: 32,
  keyCode: 32
};
export var PageUp = {
  key: 'PageUp',
  which: 33,
  keyCode: 33
};
export var PageDown = {
  key: 'PageDown',
  which: 34,
  keyCode: 34
};
export var End = {
  key: 'End',
  which: 35,
  keyCode: 35
};
export var Home = {
  key: 'Home',
  which: 36,
  keyCode: 36
};
export var ArrowLeft = {
  key: 'ArrowLeft',
  which: 37,
  keyCode: 37
};
export var ArrowUp = {
  key: 'ArrowUp',
  which: 38,
  keyCode: 38
};
export var ArrowRight = {
  key: 'ArrowRight',
  which: 39,
  keyCode: 39
};
export var ArrowDown = {
  key: 'ArrowDown',
  which: 40,
  keyCode: 40
};